module.exports = __webpack_public_path__ + "img/SiteDashboard.dfe8622a.svg";